import {
  EDIT_USER,
  RECEIVE_USERS,
  CANCEL_EDIT_USER,
  PATCH_EDIT_USER
} from "../actions/users";

import {
  EDIT_COST_LIMIT,
  RECEIVE_COST_LIMITS,
  CANCEL_EDIT_COST_LIMIT,
  PATCH_EDIT_COST_LIMIT
} from "../actions/costLimits";

import {
  EDIT_ACCOUNT_SETTINGS,
  RECEIVE_ACCOUNT_SETTINGS,
  CANCEL_EDIT_ACCOUNT_SETTINGS,
  PATCH_EDIT_ACCOUNT_SETTINGS,
  NEW_ACCOUNT_SETTINGS
} from "../actions/accountSettings";

import {
  CANCEL_CREATE_INVOICE,
  CREATE_INVOICE,
  PATCH_EDIT_INVOICE
} from "../actions/invoices";

const initialState = {
  editUser: {},
  editCostLimit: {},
  editAccountSettings: {},
  createInvoice: {
    open: false,
    data: []
  }
};

function modalForm(state = initialState, action) {
  switch (action.type) {
    // USERS
    case EDIT_USER:
      const { id, active, role } = action;
      return Object.assign({}, state, { editUser: { id, active, role } });

    case CANCEL_EDIT_USER:
      return { ...state, editUser: initialState.editUser };

    case PATCH_EDIT_USER:
      const editUser = Object.assign({}, state.editUser, action.patch);
      return { ...state, editUser };

    case RECEIVE_USERS:
      return { ...state, editUser: initialState.editUser };

    // COST LIMITS
    case EDIT_COST_LIMIT:
      return {
        ...state,
        editCostLimit: {
          id: action.id,
          isRecurring: action.isRecurring
        }
      };

    case CANCEL_EDIT_COST_LIMIT:
      return { ...state, editCostLimit: initialState.editCostLimit };

    case RECEIVE_COST_LIMITS:
      return { ...state, editCostLimit: initialState.editCostLimit };

    case PATCH_EDIT_COST_LIMIT:
      const editCostLimit = Object.assign(
        {},
        state.editCostLimit,
        action.patch
      );
      return { ...state, editCostLimit };

    // ACCOUNT SETTINGS

    case NEW_ACCOUNT_SETTINGS:
      return {
        ...state,
        editAccountSettings: {
          id: "NEW",
          accountId: action.accountId
        }
      };

    case EDIT_ACCOUNT_SETTINGS:
      return {
        ...state,
        editAccountSettings: {
          ...action.accountSettings
        }
      };

    case CANCEL_EDIT_ACCOUNT_SETTINGS:
      return {
        ...state,
        editAccountSettings: initialState.editAccountSettings
      };

    case RECEIVE_ACCOUNT_SETTINGS:
      return {
        ...state,
        editAccountSettings: initialState.editAccountSettings
      };

    case PATCH_EDIT_ACCOUNT_SETTINGS:
      const editAccountSettings = Object.assign(
        {},
        state.editAccountSettings,
        action.patch
      );
      return { ...state, editAccountSettings };

    case CREATE_INVOICE:
      return Object.assign({}, state, {
        createInvoice: { open: true, data: action.data }
      });

    case CANCEL_CREATE_INVOICE:
      return Object.assign({}, state, {
        createInvoice: initialState.createInvoice
      });

    case PATCH_EDIT_INVOICE:
      const createInvoice = Object.assign(
        {},
        state.createInvoice,
        action.patch
      );
      return Object.assign({}, state, { createInvoice });

    default:
      return state || initialState;
  }
}

export default modalForm;



// WEBPACK FOOTER //
// ./src/reducers/modalForm.js